import * as fromStorage from '@store/reducers/storage.reducer';
import * as fromConfig from '@store/reducers/config.reducer';
import * as fromAuthentication from '@store/reducers/authentication.reducers';
import * as fromApp from '@store/reducers/global.reducer';
import * as fromUser from '@store/reducers/user.reducer';
import * as fromShoppingCart from '@store/reducers/shopping-cart';


export const appReducers = {
  storage: fromStorage.reducer,
  config: fromConfig.reducer,
  global: fromApp.reducer,
  shoppingCart: fromShoppingCart.reducer,
  authentication: fromAuthentication.reducer,
  user: fromUser.reducer
};

